var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"half",attrs:{"id":"home"}},[_c('div',{staticClass:"big mbig",domProps:{"innerHTML":_vm._s(_vm.home.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }